module.exports = __webpack_public_path__ + "static/media/image-card-5.7ce6d36f.png";